import { useDataChange } from 'Simple/Data'

export function useOnClearProviders(props) {
  let change = useDataChange({
    context: 'tab',
    viewPath: props.viewPath,
    path: 'selected.sidebar_employee_resources',
  })

  return function onClick() {
    change([])
  }
}
